module.exports = __webpack_public_path__ + "static/img/in-askari-life.a64f1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/in-askari-life.png
// module id = Omg6
// module chunks = 1